import type { FC } from 'react'

import data from './data'

export interface ScoreProps {
  active?: boolean
}

interface ScoreIllustrationProps {
  score: number
}

export const colors = {
  dashColor: `#AEB2C1`,
  defaultTextColor: `#606B85`,
  activeTextColor: `#394762`,
  defaultColumnFill: `#E1E3EA`,
}

const ScoreChart: FC<ScoreIllustrationProps> = ({ score }) => {
  return (
    <svg viewBox="0 0 641 348" fill="none" xmlns="http://www.w3.org/2000/svg">
      {data.map(({ slug, component: Component }, index) => (
        <Component key={slug} active={index === score} />
      ))}
      <path
        d="M1 1H617.5"
        stroke={colors.dashColor}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeDasharray="4 8"
      />
      <path
        d="M1 75H461.5"
        stroke={colors.dashColor}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeDasharray="4 8"
      />
      <path
        d="M1 149H306.5"
        stroke={colors.dashColor}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeDasharray="4 8"
      />
      <path
        d="M1 222H149.5"
        stroke={colors.dashColor}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeDasharray="4 8"
      />
    </svg>
  )
}

export default ScoreChart
